
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/links",
      function () {
        return require("private-next-pages/links.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/links"])
      });
    }
  